export const formatDate = (date) =>{
    if(date === undefined || date === null || date === "")
    {
      return date;
    }
    return new Date(date).toDateString()
  }
  export default formatDate